exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".disclaimer {\n  font-family: \"Source Sans Pro\", \"Helvetica Neue\", \"Helvetica\";\n  text-align: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./src/js/components/Disclaimer/disclaimer.scss
// module id = 262
// module chunks = 0